import { FloatingIcon } from './FloatingIcon.js';
import { Designer } from './Designer.js';
import { Toolbar } from './Toolbar.js';
import { BugMarker } from './BugMarker.js';
import { ReportingModal } from './ReportingModal.js';
import { Notification } from './Notification.js';

// The legacy <waylight-canvas> is gone — its Snap.svg drawing role is now
// owned by the Konva engine inside <waylight-designer>'s shadow root.

export function registerComponents() {
    if (!customElements.get('waylight-floating-icon')) {
        customElements.define('waylight-floating-icon', FloatingIcon);
    }

    if (!customElements.get('waylight-designer')) {
        customElements.define('waylight-designer', Designer);
    }

    if (!customElements.get('waylight-toolbar')) {
        customElements.define('waylight-toolbar', Toolbar);
    }

    if (!customElements.get('waylight-bug-marker')) {
        customElements.define('waylight-bug-marker', BugMarker);
    }

    if (!customElements.get('waylight-reporting-modal')) {
        customElements.define('waylight-reporting-modal', ReportingModal);
    }

    if (!customElements.get('waylight-notification')) {
        customElements.define('waylight-notification', Notification);
    }
}

export {
    FloatingIcon,
    Designer,
    Toolbar,
    BugMarker,
    ReportingModal,
    Notification,
};
